import React from 'react';
import { Award, Users, Clock as ClockIcon, Sparkles } from 'lucide-react';
import { shopInfo } from '../../mock';

export const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="space-y-6">
            <div className="space-y-2">
              <h2 className="text-4xl lg:text-5xl font-bold text-stone-900">
                About Us
              </h2>
              <p className="text-lg text-maroon-800 font-semibold">
                Formerly {shopInfo.formerName}
              </p>
            </div>

            <p className="text-lg text-stone-700 leading-relaxed">
              {shopInfo.description}
            </p>

            <div className="bg-maroon-800/10 border-l-4 border-maroon-800 p-6 rounded-r">
              <p className="text-stone-800 font-medium">
                Owned and operated by <span className="font-bold text-maroon-900">{shopInfo.owner}</span> since {shopInfo.ownedSince}, 
                we pride ourselves on providing exceptional grooming services in a welcoming, 
                traditional atmosphere.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4 pt-4">
              <div className="bg-white p-6 rounded-lg border border-stone-200 hover:border-maroon-700 transition-all duration-200 hover:shadow-lg">
                <div className="flex items-center space-x-3">
                  <div className="bg-maroon-100 p-3 rounded-lg">
                    <Award className="h-6 w-6 text-maroon-800" />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-stone-900">{shopInfo.ownedSince}</p>
                    <p className="text-sm text-stone-600">Since</p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-lg border border-stone-200 hover:border-maroon-700 transition-all duration-200 hover:shadow-lg">
                <div className="flex items-center space-x-3">
                  <div className="bg-maroon-100 p-3 rounded-lg">
                    <Users className="h-6 w-6 text-maroon-800" />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-stone-900">{shopInfo.totalReviews}+</p>
                    <p className="text-sm text-stone-600">Happy Clients</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Visual Element */}
          <div className="relative">
            <div className="bg-stone-700 rounded-2xl p-8 shadow-2xl border border-stone-600">
              <div className="space-y-6">
                <div className="flex items-start space-x-4 p-4 bg-stone-600/50 rounded-lg backdrop-blur-sm border border-stone-500">
                  <div className="bg-maroon-800 p-3 rounded-lg flex-shrink-0">
                    <Sparkles className="h-6 w-6 text-stone-100" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-stone-100 mb-2">Traditional Atmosphere</h3>
                    <p className="text-stone-400 text-sm">
                      Step back in time with our authentic vintage decor and old-school barbering experience.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4 p-4 bg-stone-600/50 rounded-lg backdrop-blur-sm border border-stone-500">
                  <div className="bg-maroon-800 p-3 rounded-lg flex-shrink-0">
                    <Users className="h-6 w-6 text-stone-100" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-stone-100 mb-2">Community Favorite</h3>
                    <p className="text-stone-400 text-sm">
                      Popular with locals and Mississippi State University students alike.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4 p-4 bg-stone-600/50 rounded-lg backdrop-blur-sm border border-stone-500">
                  <div className="bg-maroon-800 p-3 rounded-lg flex-shrink-0">
                    <ClockIcon className="h-6 w-6 text-stone-100" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-stone-100 mb-2">Decades of Expertise</h3>
                    <p className="text-stone-400 text-sm">
                      Years of experience delivering quality cuts and exceptional service.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
